module.exports = __webpack_public_path__ + "static/media/box-dark-small.93b124c4.png";